import { ModalHeader } from '@/components/Modal'

import { useTexts } from '../useTexts'
import { useController } from '../hooks/useController'

export function Header() {
  const {
    invalid,
    data: { mode },
  } = useController()
  const texts = useTexts()

  return (
    <ModalHeader title={invalid ? texts.emptyOrdersTitle : texts.title(mode === 'bulk' ? 2 : 1)} />
  )
}
